import {
  Button,
  Input,
  SelectSearch,
  Form,
  InputMask,
  ModalFooter,
} from "@telluscompany/design-system";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { createUserSchema, UserFormData } from "../../schemas";
import { useLocalization } from "@i18n";
import { UserRole } from "../../types";

interface CreateUserFormProps {
  onSubmit: (data: UserFormData) => void;
  onCancel: () => void;
}

export const CreateUserForm = ({ onSubmit, onCancel }: CreateUserFormProps) => {
  const { translate } = useLocalization();

  const form = useForm<UserFormData>({
    resolver: zodResolver(createUserSchema(translate)),
    defaultValues: {},
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="px-[32px] py-[16px]">
          <div className="grid grid-cols-2 gap-4">
            <Input
              control={form.control}
              label={translate("management.users.form.label.name")}
              name="name"
              type="text"
              placeholder={translate("management.users.form.placeholder.name")}
            />
            <Input
              control={form.control}
              label={translate("management.users.form.label.email")}
              name="email"
              type="email"
              placeholder={translate("management.users.form.placeholder.email")}
            />
            <SelectSearch
              control={form.control}
              label={translate("management.users.form.label.role")}
              name="role"
              placeholder={translate(
                "management.users.form.placeholder.roleSelect",
              )}
              options={[
                { label: "Owner", value: UserRole.owner },
                { label: "Owner Viewer", value: UserRole.ownerViewer },
                { label: "User", value: UserRole.user },
              ]}
            />
            <InputMask
              control={form.control}
              label={translate("management.users.form.label.phone")}
              name="phone"
              type="text"
              mask="(99) 99999-9999"
            />
            <Input
              control={form.control}
              label={translate("management.users.form.label.department")}
              name="department"
              type="text"
              placeholder={translate(
                "management.users.form.placeholder.department",
              )}
            />
            <Input
              control={form.control}
              label={translate("management.users.form.label.position")}
              name="position"
              type="text"
              placeholder={translate(
                "management.users.form.placeholder.position",
              )}
            />
          </div>
        </div>
        <ModalFooter
          footer={
            <Button type="submit" variant="primary">
              {translate("management.users.button.save")}
            </Button>
          }
          closeModal={
            <Button type="button" variant="secondary" onClick={onCancel}>
              {translate("management.users.button.cancel")}
            </Button>
          }
        />
      </form>
    </Form>
  );
};
